module.exports = __webpack_public_path__ + "img/logo1.b0fe5ca6.png";